export default "__VITE_ASSET__2483c3a2__"